/**
 * Patch que o `Aprovar` do painel manda junto do aceite — o caminho que NÃO passa por formulário.
 *
 * Existe porque o builder depende da CATEGORIA e os três pontos de chamada usavam o de ATIVO para
 * as duas: numa sugestão de movimentação nenhum campo casava, o retorno degradava para `null` e o
 * backend aplicava só o que a IA propôs. Funcionava por acidente, não por desenho.
 */
import { ehDeMovimentacao } from '@modules/consolidator/utils/suggestions-categoria/suggestions-categoria'
import { dadosDoAceite } from '@modules/consolidator/utils/suggestion-to-asset/suggestion-to-asset'
import { dadosDoAceiteMov } from '@modules/consolidator/utils/suggestion-to-movimentacao/suggestion-to-movimentacao'

export const dadosDoAceitePorCategoria = (suggestion) =>
  ehDeMovimentacao(suggestion) ? dadosDoAceiteMov(suggestion) : dadosDoAceite(suggestion)
